import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-sign-in-verify-email',
  templateUrl: './sign-in-verify-email.component.html',
  styleUrls: ['./sign-in-verify-email.component.css']
})
export class SignInVerifyEmailComponent implements OnInit {

  constructor(
    public authService: AuthService
  ) { }

  ngOnInit(): void {
  }

}
